import React from "react";
import { homeDeviceLogGraph } from "../../constant/urls/apiUrls";
const RenderPythonGraph = ({ deviceId, startDateTime, endDateTime }) => {
    return (
        <iframe src={homeDeviceLogGraph + deviceId + "&from_date=" + startDateTime + "&to_date=" + endDateTime} title="Device Log Graph" className="w-full h-[65rem]"></iframe>
    );
};

export default RenderPythonGraph;
